import { Controller } from '@hotwired/stimulus';

interface AuthorizeNetResponse {
  opaqueData: {
    dataValue: string;
    dataDescriptor: string;
  };
  messages: {
    resultCode: string;
  };
}

// Declare the global handler that AcceptUI expects
declare global {
  interface Window {
    authorizeNetResponseHandler: (response: AuthorizeNetResponse) => void;
  }
}

export default class AuthorizeNetController extends Controller {
  public static targets = ['dataValue', 'dataDescriptor', 'submitButton'];

  declare public readonly dataValueTarget: HTMLInputElement;
  declare public readonly dataDescriptorTarget: HTMLInputElement;
  declare public readonly submitButtonTarget: HTMLButtonElement;

  public connect(): void {
    // Define the global response handler that AcceptUI will call
    window.authorizeNetResponseHandler =
      this.handleAuthorizeNetResponse.bind(this);

    // If we have existing values (from form reload), update button state
    if (this.dataValueTarget.value && this.dataDescriptorTarget.value) {
      this._updateButtonState();
    }
  }

  public handleAuthorizeNetResponse(response: AuthorizeNetResponse): void {
    const { opaqueData, messages } = response;

    if (messages.resultCode === 'Ok') {
      this.dataValueTarget.value = opaqueData.dataValue;
      this.dataDescriptorTarget.value = opaqueData.dataDescriptor;

      // Trigger change events for form validation
      this.dataValueTarget.dispatchEvent(new Event('change'));
      this.dataDescriptorTarget.dispatchEvent(new Event('change'));

      this._updateButtonState();
    } else {
      console.error(messages);
    }
  }

  private _updateButtonState(): void {
    this.submitButtonTarget.textContent = 'Paying with card';
    this.submitButtonTarget.disabled = true;
  }
}
